import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "./Slider.scss";
import Yellowbar from "../../assets/images/yellowbar.svg";
import smilegirl from "../../assets/images/smilegirl.svg";
import testiimage from "../../assets/images/testiimage.jpg";
import { testimonialContent } from "./testimonialContent";
function SliderComponent(props) {
  const [mobileView, setMobileView] = useState(false);

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 767
        ? setMobileView(true)
        : setMobileView(false);
    };

    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);

  const settings = {
    autoplay: true,
    dots: true,
    infinite: true,
    speed: 100,
    slidesToShow: 2.3,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        },
      },
    ],
  };

  return (
    <div className="mainslide">
      <div
        className="customersSay"
        style={
          props.mob == true
            ? { textAlign: "center", whiteSpace: "nowrap", fontSize: "20px" }
            : {}
        }
      >
        What our customers say
      </div>
      <div className="yellowbar">
        {" "}
        <img src={Yellowbar} alt="Yellowbar" />
      </div>

      <div className="s">
        <Slider {...settings}>
          {testimonialContent &&
            testimonialContent.map((item, index) => (
           
              <Slide
                key={index}
                  view={mobileView}
                  feedBack={item.userFeedback}
                  users={item.userName}
                  image={item.image}
                />
            ))}

          {/* <Slide view={mobileView} />

          <Slide view={mobileView} /> */}
        </Slider>
      </div>
    </div>
  );
}

const Slide = ({ view, feedBack, users, image }) => {
  return (
    <div>
      {!view ? (
        <div className="slidecard">
          <img src={image} alt="testiimages" />
          <div className="contentsmile">
            <div className="contentsmiletext">{feedBack}</div>
            <div className="name">{users}</div>
          </div>
        </div>
      ) : (
        <div className="mobslidecard">
          <div className="contentsmiletext">{feedBack}</div>
          <div className="avatarholder">
            <img src={image} alt="testiimages" />
            <div className="name">{users}</div>
          </div>
        </div>
      )}
    </div>
  );
};
export default SliderComponent;
